<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'svg-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon_menu {
  width: 1.5em;
  height: 1.5em;
  fill: currentColor;
  overflow: hidden;
  margin-right: 10px;
}

.svg-icon_monitor {
  width: 3em;
  height: 3em;
  overflow: hidden;
  fill: currentColor;
  fill: #454945;
}

.svg-icon_error {
  width: 1.5em;
  height: 1.5em;
  overflow: hidden;
  fill: currentColor;
  fill: #454945;
}

.svg-icon_monitor2 {
  width: 2.2em;
  height: 2.2em;
  overflow: hidden;
  fill: currentColor;
  fill: #30b130;
}

.svg-elevator_page_monitor {
  width: 28em;
  height: 28em;
  overflow: hidden;
}

// 页面菜单收起按钮样式
.onScollop {
  width: 1em;
  height: 1em;
  margin-right: 20px;
  /* Rotate div 旋转 各个浏览器的不同选择*/
  transform: rotate(0deg);
  -ms-transform: rotate(0deg); /* Internet Explorer */
  -moz-transform: rotate(0deg); /* Firefox */
  -webkit-transform: rotate(0deg); /* Safari 和 Chrome */
  -o-transform: rotate(0deg);
  transition: all 0.3s;
  margin-left: 30px;
}
// 页面菜单展开按钮样式
.upScollop {
  width: 1em;
  height: 1em;
  margin-right: 20px;
  /* Rotate div 旋转 各个浏览器的不同选择*/
  transform: rotate(90deg);
  -ms-transform: rotate(90deg); /* Internet Explorer */
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
  -o-transform: rotate(-90deg);
  transition: all 0.3s;
  margin-left: 30px;
}

.routeCurrentInfo {
  width: 1.5em;
  height: 1.5em;
  margin-right: 0px;
}

.amplification {
  width: 1.5em;
  height: 1.5em;
  margin-right: 20px;
}

.shrink {
  width: 1.5em;
  height: 1.5em;
  margin-right: 20px;
}

.svg-icon_not_video {
  width: 10em;
  height: 10em;
  fill: currentColor;
  overflow: hidden;
  margin-left: 180px;
  margin-top: 20px;
}

.svg-icon_home_index {
  width: 2.5em;
  height: 2.5em;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon_home_title {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon_home_no_data {
  width: 10em;
  height: 10em;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon_statistical_no_data {
  width: 15em;
  height: 15em;
  margin-top: 80px;
  fill: currentColor;
  overflow: hidden;
}
</style>
